import {h} from 'preact';
import register from 'preact-custom-element';
import CartItemsCount from '@/components/cart/CartItemsCount'


register(() => h(CartItemsCount, { }), 'cart-items-count');

